import { memo, useState, useLayoutEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { CALYPSO, CANDY_APPLE, LORAX } from 'HubStyleTokens/colors';
import { emptyFn } from '../utils/emptyFn';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const randomNum = (min, max) => {
  return min + Math.floor(Math.random() * (max - min + 1));
};
const rain = keyframes(["from{opacity:0;}25%{opacity:1;}to{bottom:0;}"]);
const confettiStyle = css(["animation:", " ease-out forwards;background:", ";border-radius:2px;bottom:100%;height:16px;opacity:0;position:absolute;width:5px;z-index:3;&:nth-child(odd){background:", ";}&:nth-child(even){z-index:1;}&:nth-child(3n){animation-duration:", "ms;height:25px;width:7px;}&:nth-child(4n){animation-duration:", "ms;border-radius:50%;height:10px;width:10px;}&:nth-child(4n-7){background:", ";}&:nth-child(8n){height:30px;width:4px;}"], rain, LORAX, CALYPSO, props => props.duration * 2, props => props.duration * 1.8, CANDY_APPLE);
const getConfettiPieceStyle = duration => {
  const randomDuration = randomNum(duration * 0.6, duration * 1.3);
  const randomDelay = randomNum(0, duration * 0.75);
  return {
    animationDelay: `${randomDelay}ms`,
    animationDuration: `${randomDuration}ms`,
    left: `${randomNum(0, 100)}%`,
    transform: `rotate(${randomNum(-80, 80)}deg)`
  };
};
const Confetti = ({
  className,
  duration = 3000,
  pieces = 60
}) => {
  const [confettiPieces, setConfettiPieces] = useState([]);
  useLayoutEffect(() => {
    if (!Array.isArray(confettiPieces)) {
      return emptyFn;
    }
    if (confettiPieces.length >= pieces) {
      const timeoutId = setTimeout(() => setConfettiPieces(null), duration * 2);
      return () => clearTimeout(timeoutId);
    }
    const newConfettiPieces = [...confettiPieces];
    for (let index = 0; index < 10; index += 1) {
      newConfettiPieces.push( /*#__PURE__*/_jsx("div", {
        className: className,
        style: getConfettiPieceStyle(duration)
      }, confettiPieces.length + index));
    }
    const requestId = requestAnimationFrame(() => setConfettiPieces(newConfettiPieces));
    return () => cancelAnimationFrame(requestId);
  }, [className, duration, pieces, confettiPieces, setConfettiPieces]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: confettiPieces
  });
};
const StyledConfetti = /*#__PURE__*/memo(styled(Confetti).withConfig({
  displayName: "Confetti__StyledConfetti",
  componentId: "sc-1ie9wh0-0"
})(["", ""], confettiStyle));
export default StyledConfetti;